import { useFormContext } from 'react-hook-form';
import { Chip, createFilterOptions, styled } from '@mui/material';
import { LwFormMultiSelect } from 'redesign';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { FlexpoolOption, FlexpoolsFilterFormContext } from './filter-flexpools.types';

type Props = {
  companyFlexpools: FlexpoolOption[];
  disabled?: boolean;
};

export const FilterFlexpools = (props: Props) => {
  const { companyFlexpools, disabled } = props;
  const { t } = useTranslation('web-common');
  const { control } = useFormContext<FlexpoolsFilterFormContext>();
  const filterOptions = useCallback(
    createFilterOptions<FlexpoolOption>({
      stringify: ({ label }: FlexpoolOption) => label,
    }),
    []
  );

  return (
    <LwFormMultiSelect
      name={'flexpools'}
      control={control}
      options={companyFlexpools}
      disabled={disabled}
      label={t('filters.flexpools.label')}
      getOptionKey={(option) => option.value}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderOption={(props, option) => (
        <Option {...props} key={option.value}>
          <Chip label={option.label} />
        </Option>
      )}
      filterOptions={filterOptions}
      data-testid="flexpools-filter"
    />
  );
};

const Option = styled('li')(({ theme }) => ({
  display: 'flex',
  '.MuiChip-root': {
    backgroundColor: theme.palette.lwPrimaryAccentLight[10],
    marginBottom: 0,
    borderRadius: theme.spacing(6),
    height: 'auto',
    whiteSpace: 'normal',
  },
  '.MuiChip-label': {
    color: theme.palette.lwPrimaryAccentLight[100],
    width: 'auto',
    height: 'auto',
    whiteSpace: 'normal',
    overflow: 'visible',
  },
}));
